import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../../utils/axios';
import { SUBSCRIBE_GIFT_INDEX } from 'src/constants/queryKeys';

export const networkGenerateGiftCode = async (payload) => {
  const res = await axiosInstance.post(`/SubscribePackageGiftCode/GenerateGiftCodes`, payload);
  return res;
};

export const networkGiftIndexList = async (payload, pageIndex = 0, pageSize = 100) => {
  const res = await axiosInstance.post(`SubscribePackageGiftCode/List/${pageIndex}/${pageSize}/`, payload);
  return res?.data;
};

export function useGiftIndexList(payload, pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: [SUBSCRIBE_GIFT_INDEX, pageIndex, payload],
    queryFn: () => networkGiftIndexList(payload, pageIndex, pageSize),
  });
}
